// Personel istatistik kartlarının ızgara yerleşimi — Ana Sayfa istatistik
// kartlarıyla (DashboardStatisticsCards) aynı kural:
//   • mobil 1 sütun, ≥640px 2 sütun, ≥1024px kartlar iki eşit satıra,
//     ≥1700px tek satıra yayılır;
//   • son satırda boşluk kalmaz: sütun sayısına bölünmeyen hücre sayısında son
//     hücre (durum hücresi, yoksa son ana kart) satırın kalanını doldurur.
// Durum hücresi (Özel Rol / Aktif Vekalet / Engellenen küçük kartları yan yana)
// 3 küçük kart taşıyorsa okunaklı kalsın diye 2 sütun genişliğinde sayılır.

export const LAYOUT_TIERS = ['base', 'sm', 'lg', 'xl'];

// Tek bir kırılım için: son ana kart ve durum hücresi kaç sütun kaplar.
function tierSpans(cols, mainCount, statusWeight) {
  const r = mainCount % cols; // son (yarım) satırdaki ana kart sayısı
  if (!statusWeight) {
    return { cols, lastMainSpan: r === 0 ? 1 : cols - r + 1, statusSpan: 0 };
  }
  const need = Math.min(statusWeight, cols);
  if (r === 0) return { cols, lastMainSpan: 1, statusSpan: cols };
  const free = cols - r;
  if (free >= need) return { cols, lastMainSpan: 1, statusSpan: free };
  // Durum hücresi bu satıra sığmıyor: son ana kart satırı doldurur, durum
  // hücresi yeni satırın tamamını alır.
  return { cols, lastMainSpan: free + 1, statusSpan: cols };
}

/**
 * @param {number} mainCount   Ana kart sayısı (Toplam, Park Görevlisi, ekipler, rol kartları)
 * @param {number} statusCount Durum hücresindeki küçük kart sayısı (0 = durum hücresi yok)
 * @returns {{base,sm,lg,xl}} her kırılım için { cols, lastMainSpan, statusSpan }
 */
export function personnelStatGridLayout(mainCount, statusCount) {
  const main = Math.max(0, mainCount | 0);
  const statusWeight = statusCount > 0 ? (statusCount >= 3 ? 2 : 1) : 0;
  const units = main + statusWeight;
  if (units === 0) return null;
  const cols = {
    base: 1,
    sm: Math.min(2, units),
    lg: Math.max(1, Math.ceil(units / 2)),
    xl: units <= 10 ? units : Math.ceil(units / 2),
  };
  const out = {};
  LAYOUT_TIERS.forEach((tier) => {
    out[tier] = tierSpans(cols[tier], main, statusWeight);
  });
  return out;
}

// CSS değişkenleri (ızgara sınıfları bunları okur; sınıf adları sabit kalır ki
// Tailwind derlemede görsün).
export function personnelStatGridStyle(layout) {
  if (!layout) return undefined;
  const suffix = { base: '', sm: '-sm', lg: '-lg', xl: '-xl' };
  const style = {};
  LAYOUT_TIERS.forEach((tier) => {
    const t = layout[tier];
    style[`--ps-c${suffix[tier]}`] = t.cols;
    style[`--ps-m${suffix[tier]}`] = t.lastMainSpan;
    style[`--ps-s${suffix[tier]}`] = t.statusSpan || 1;
  });
  return style;
}

// Kırılımlar Tailwind ile aynı: sm=640px, lg=1024px, min-[1700px] (Ana Sayfa ile aynı eşik).
export const PS_GRID_CLASS =
  'grid gap-4 [grid-template-columns:repeat(var(--ps-c),minmax(0,1fr))] ' +
  'sm:[grid-template-columns:repeat(var(--ps-c-sm),minmax(0,1fr))] ' +
  'lg:[grid-template-columns:repeat(var(--ps-c-lg),minmax(0,1fr))] ' +
  'min-[1700px]:[grid-template-columns:repeat(var(--ps-c-xl),minmax(0,1fr))]';

export const PS_LAST_MAIN_CLASS =
  '[grid-column:span_var(--ps-m)/span_var(--ps-m)] ' +
  'sm:[grid-column:span_var(--ps-m-sm)/span_var(--ps-m-sm)] ' +
  'lg:[grid-column:span_var(--ps-m-lg)/span_var(--ps-m-lg)] ' +
  'min-[1700px]:[grid-column:span_var(--ps-m-xl)/span_var(--ps-m-xl)]';

export const PS_STATUS_CLASS =
  '[grid-column:span_var(--ps-s)/span_var(--ps-s)] ' +
  'sm:[grid-column:span_var(--ps-s-sm)/span_var(--ps-s-sm)] ' +
  'lg:[grid-column:span_var(--ps-s-lg)/span_var(--ps-s-lg)] ' +
  'min-[1700px]:[grid-column:span_var(--ps-s-xl)/span_var(--ps-s-xl)]';

// Durum hücresinin iç ızgarası (küçük kart sayısına göre; literal sınıflar).
export const PS_STATUS_INNER_COLS = { 1: 'grid-cols-1', 2: 'grid-cols-2', 3: 'grid-cols-3' };
